export default "/images/479d94d792bd2c5432b451cdb7bfa3ea.avif";